import { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { Checkbox, FormControlLabel } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import MaisPraticoKPIBlack from "../../public/PNG/MaisPraticoKPIBlack.png"
import LogoB2B from "../../public/PNG/LogoB2B.png"
import { LoadingButton } from '@mui/lab';
import { version } from '../../services/version';
import MyContext from '../../contexts/myContext';
import { SENHA } from './ComponentsLogin/SENHA';
import { CNPJ } from './ComponentsLogin/CNPJ';
import { NOME } from './ComponentsLogin/NOME';
import { FormPrimeiroAcesso } from './ComponentsLogin/FormPrimeiroAcesso';
import { GravaLogB2B } from './functions/GravaLogB2B';

export default function Login(props) {

    const [idUsuario, setIdUsuario] = useState('')
    const [senha, setSenha] = useState('')
    const [cnpj, setCnpj] = useState('')
    const [lembrarMe, setlembrarMe] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [steps, setSteps] = useState(0);

    const { vCloseKPI, setvCloseKPI } = useContext(MyContext)

    // Função para limpar a URL e redirecionar para a raiz
    const limparParametros = () => {
        window.location.href = '/'; // Redireciona para a página raiz
    };


    function getManterLoginLocalStorage() {

        try {
            if (localStorage.manterLogin === "true") {
                localStorage.manterLogin = "false"
                handleLogin()
            }
        } catch (error) {
            localStorage.manterLogin = "false"
            console.log('ERRO NO MANTER LOGIN: ' + error)
        }
    }

    const [isPrimeiroAcesso, setIsPrimeiroAcesso] = useState(false)

    async function FazerLogin(empresa) {

    }


    async function handleLogin() {
        setIsLoading(true)
        let cnpj_HTML = window.document.getElementById('outlined-basic cnpj').value

        if (!cnpj_HTML) {
            cnpj_HTML = cnpj
        }

        const cnpjUnFormat = cnpj_HTML.replace('.', '').replace('.', '').replace('/', '').replace('-', '')

        await api.get(`/api/getDadosEmpresaFromCNPJ/${cnpjUnFormat}`)
            .then(data => {
                const dadosEmpresa = data.data

                console.log('dadosEmpresa')
                console.log(dadosEmpresa)

                if (dadosEmpresa?.length === 0) {
                    Swal.fire({
                        icon: 'error',
                        text: 'Empresa não cadastrada. Verifique o CNPJ informado e tente novamente!',
                        showConfirmButton: false,
                        timer: 4000
                    })
                    return
                }

                FazerLogin(dadosEmpresa[0])
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    text: 'Erro ao obter os dados da Empresa informada. Erro: ' + error,
                    showConfirmButton: false,
                    timer: 5000
                })
                console.log(error)
                setIsLoading(false)
            })

        setIsLoading(false)
    }

    async function getDadosFromLocalStorage() {
        // const pathname = window.location?.pathname;
        // console.log('################## pathname')
        // console.log(pathname)
        // // Dividir a URL nos parâmetros esperados
        // const pathParts = pathname.split('/');
        // console.log('pathParts')
        // console.log(pathParts.length)
        // console.log(pathParts)

        // if (pathParts.length === 5) {
        //     const UserParam = pathParts[2]
        //     const SenhaParam = pathParts[3]
        //     const CNPJParam = pathParts[4]
        //     setIdUsuario(UserParam)
        //     setSenha(SenhaParam)
        //     setCnpj(CNPJParam)


        //     window.document.getElementById('outlined-password-input senha').value = SenhaParam
        //     window.document.getElementById('outlined-basic cnpj').value = CNPJParam

        //     setlembrarMe(true);
        //     localStorage.lembrarMe = true
        //     localStorage.MaisPratico = true
        //     await handleLogin();

        // }
        // else {
        setIdUsuario(localStorage?.idUsuario || '')
        setSenha(localStorage?.senha || '')
        setCnpj(localStorage?.cnpj || '')
        setlembrarMe(localStorage?.lembrarMe === "true" ? true : false)
        localStorage.MaisPratico = false
        //}
    }

    if (cnpj) {
        getManterLoginLocalStorage()
    }

    useEffect(() => {
        getDadosFromLocalStorage()
        if (cnpj) {
            getManterLoginLocalStorage()
        }

    }, [])



    const handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 2].focus();
            event.preventDefault();
        }
    };

    // const cnpjMask = (value) => {
    //     return value
    //         .replace(/\D+/g, '') // não deixa ser digitado nenhuma letra
    //         .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
    //         .replace(/(\d{3})(\d)/, '$1.$2')
    //         .replace(/(\d{3})(\d)/, '$1/$2') // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
    //         .replace(/(\d{4})(\d)/, '$1-$2')
    //         .replace(/(-\d{2})\d+?$/, '$1') // captura os dois últimos 2 números, com um - antes dos dois números
    // }

    const cnpjMask = (value) => {
        try {
            const numericValue = value.replace(/\D+/g, ''); // Remove qualquer caractere que não seja número

            if (numericValue.length <= 11) {
                // Máscara de CPF (11 dígitos)
                return numericValue
                    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona ponto após os 3 primeiros dígitos
                    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona ponto após os 6 primeiros dígitos
                    .replace(/(\d{3})(\d{1,2})$/, '$1-$2'); // Adiciona hífen antes dos últimos 2 dígitos
            } else if (numericValue.length <= 14) {
                // Máscara de CNPJ (14 dígitos)
                return numericValue
                    .replace(/(\d{2})(\d)/, '$1.$2') // Adiciona ponto após os 2 primeiros dígitos
                    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona ponto após os 5 primeiros dígitos
                    .replace(/(\d{3})(\d)/, '$1/$2') // Adiciona barra após os 8 primeiros dígitos
                    .replace(/(\d{4})(\d{1,2})$/, '$1-$2'); // Adiciona hífen antes dos últimos 2 dígitos
            } else {
                // Caso exceda 14 dígitos, retorna apenas os primeiros 14 formatados
                return numericValue.substring(0, 14)
                    .replace(/(\d{2})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1/$2')
                    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
            }
        } catch (error) {
            console.log('Erro em cnpjMask: ')
            console.log(error)
        }
    };

    // Função para exibir a largura do dispositivo
    function exibirLarguraDispositivo() {
        var largura = document.documentElement.clientWidth;
        var altura = document.documentElement.clientHeight;
        return `${largura}x${altura}`;
    }



    function getNameButtonByStep(_steps) {
        if (_steps === 0) {
            return 'AVANÇAR'
        }
        if (_steps === 1) {
            return 'ENTRAR'
        }
    }

    const [NomeEmpresa, setNomeEmpresa] = useState('');

    async function handleLoginButton() {
        try {
            setIsLoading(true);
            let cnpj_HTML = window.document.getElementById('outlined-basic cnpj').value;

            if (!cnpj_HTML) {
                cnpj_HTML = cnpj;
            }

            const cnpjUnFormat = cnpj_HTML.replace('.', '').replace('.', '').replace('/', '').replace('-', '');

            const id_HTML = cnpjUnFormat;

            await api.get(`/api/getDadosLoginB2B/${cnpjUnFormat}`)
                .then(async data => {
                    const DadosLogin = data.data

                    console.log('DadosLogin')
                    console.log(DadosLogin)

                    if (DadosLogin?.length === 0) {
                        Swal.fire({
                            icon: 'error',
                            text: 'Empresa não cadastrada. Verifique o CPF/CNPJ informado e tente novamente!',
                            showConfirmButton: false,
                            timer: 4000
                        })
                        return
                    }

                    const vCodigoCliente = DadosLogin[0].CodigoCliente


                    const urlLog = `/api/getLiberacaoClienteB2B/${vCodigoCliente}`;

                    await api.get(urlLog)
                        .then(async data => {
                            const dadosLiberacao = data.data

                            console.log('dadosLiberacao')
                            console.log(dadosLiberacao)

                            if (dadosLiberacao?.length === 0) {
                                Swal.fire({
                                    icon: 'error',
                                    text: `Empresa não liberada para o acesso ao B2B!
                                    Por favor entre em contato solicitando a liberação.`,
                                    showConfirmButton: false,
                                    timer: 4000
                                })
                                return
                            }

                            if (dadosLiberacao[0].Status === 'ACESSO CANCELADO') {
                                Swal.fire({
                                    icon: 'error',
                                    text: `Acesso ao B2B Cancelado!
                                    Por favor entre em contato solicitando a liberação.`,
                                    showConfirmButton: false,
                                    timer: 4000
                                })
                                return
                            }

                            setNomeEmpresa(DadosLogin[0].Nome);

                            if (DadosLogin.length > 0) {
                                if (DadosLogin[0].PrimeiroAcesso === 1) {
                                    setIsPrimeiroAcesso(true)
                                }
                            }

                            if (steps === 0) {
                                setSteps(1)
                                return
                            }

                            const vInputSenha = window.document.getElementById('outlined-password-input senha')

                            if (vInputSenha) {
                                const senha_HTML = window.document.getElementById('outlined-password-input senha').value;

                                const UrlUser = `/usuario/api/getdadosusuarios/${id_HTML}/${senha_HTML}`;

                                await api.get(UrlUser)
                                    .then(async data => {
                                        const dadosUsuario = data.data

                                        if (dadosUsuario?.length === 0 || dadosUsuario[0]?.SenhaCorreta === 'false') {
                                            Swal.fire({
                                                icon: 'error',
                                                text: 'Usuário ou senha inválidos!',
                                                showConfirmButton: false,
                                                timer: 4000
                                            })
                                            return
                                        }

                                        const user = {
                                            idUsuario: dadosUsuario[0]?.CodigoCliente,
                                            senha: senha_HTML,
                                            cnpj: cnpjUnFormat,
                                            Nome: dadosUsuario[0]?.Nome,
                                            GodMode: dadosUsuario[0]?.GodMode,
                                            PerfilConfiguracaoAutonomiaBI: dadosUsuario[0]?.PerfilConfiguracaoAutonomiaBI
                                        }

                                        localStorage.lembrarMe = lembrarMe

                                        if (localStorage.lembrarMe) {
                                            localStorage.idUsuario = id_HTML
                                            localStorage.senha = senha_HTML
                                            localStorage.cnpj = cnpjUnFormat
                                        }
                                        else {
                                            localStorage.removeItem("idUsuario")
                                            localStorage.removeItem("senha")
                                            localStorage.removeItem("cnpj")
                                        }

                                        await GravaLogB2B("LOGIN", cnpjUnFormat);

                                        props.setarUsuario(user)
                                    })
                                    .catch(error => {
                                        Swal.fire({
                                            icon: 'error',
                                            text: 'Erro ao obter os dados do Usuário Erro: ' + error,
                                            showConfirmButton: false,
                                            timer: 5000
                                        })
                                        console.log(error)
                                    })
                            }


                        })
                        .catch(error => {
                            Swal.fire({
                                icon: 'error',
                                text: 'Erro ao obter os dados do Usuário Erro: ' + error,
                                showConfirmButton: false,
                                timer: 5000
                            })
                            console.log(error)
                        })
                })
                .catch(error => {
                    Swal.fire({
                        icon: 'error',
                        text: 'Erro ao obter os dados da Empresa informada. Erro: ' + error,
                        showConfirmButton: false,
                        timer: 5000
                    })
                    console.log(error)
                })

        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Erro ao obter os dados da Empresa informada. Erro: ' + error,
                showConfirmButton: false,
                timer: 5000
            })
            console.log(error)

        }
        finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <form className={styles.container}>
                <div className={styles.formLogin} >
                    <div className={styles.LogoDash}>
                        <img src={LogoB2B} alt='Logo B2B' />
                    </div>

                    <input
                        style={{
                            display: 'none',
                            backgroundColor: 'red',
                            width: '100%'
                        }}
                        value={vCloseKPI}
                        onChange={event => setvCloseKPI(event.target.value)}
                        id="FECHAR_KPI"
                    />

                    <div className={styles.Fields} >
                        <CNPJ setIsPrimeiroAcesso={setIsPrimeiroAcesso} steps={steps} setSteps={setSteps} handleEnter={handleEnter} cnpjMask={cnpjMask} cnpj={cnpj} setCnpj={setCnpj} styles={styles} />
                        <NOME steps={steps} NomeEmpresa={NomeEmpresa} setNomeEmpresa={setNomeEmpresa} />

                        {isPrimeiroAcesso === false ?
                            <SENHA steps={steps} handleEnter={handleEnter} setSenha={setSenha} styles={styles} senha={senha} />
                            :
                            <FormPrimeiroAcesso steps={steps} setSteps={setSteps} setIsPrimeiroAcesso={setIsPrimeiroAcesso} styles={styles} isLoading={isLoading} />
                        }

                    </div>

                    {isPrimeiroAcesso === false ?
                        <div className={styles.divBotaoLogin}>
                            <LoadingButton
                                className={styles.BotaoLogin}
                                onClick={() => handleLoginButton()}
                                color="primary"
                                loading={isLoading}
                                loadingPosition="start"
                                id="outlined-password-input btnLogin"
                                endIcon={<LoginIcon />}
                                variant="outlined"
                            >
                                {getNameButtonByStep(steps)}
                            </LoadingButton>
                        </div>
                        :
                        null
                    }

                    {steps === 1 && isPrimeiroAcesso === false ?
                        <FormControlLabel
                            control={<Checkbox

                                checked={lembrarMe}
                                onChange={() => setlembrarMe(!lembrarMe)}
                            />}
                            label="Lembrar neste Navegador"
                        />
                        : null
                    }

                    <p className='text-[0.7rem] text-white-200 absolute bottom-4 right-4'>{version}</p>
                    <p className='text-[0.7rem] text-white-200 absolute bottom-1 right-4'>{exibirLarguraDispositivo()}</p>
                </div>

            </form>

        </>
    )
}
